import React, { Component } from 'react';
import { array, object, string } from 'prop-types';
import { orderBy } from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import AssignAgentModal from '../Modals/AssignAgentModal';
import BasAgentsTable from './BasAgentsTable';
import DeleteAgentModal from '../Modals/DeleteAgentModal';
import NewAgentModal from '../Modals/NewAgentModal';
import RenameAgentModal from '../Modals/RenameAgentModal';
import ResetAgentModal from '../Modals/ResetAgentModal';
import UnAssignAgentModal from '../Modals/UnAssignAgentModal';
import AgentLinkSiteModal from '../Modals/AgentLinkSiteModal';
import EsmsPage from '../../components/EsmsPage';
import ElapsedTime from '../../components/ElapsedTime';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import * as BasAgentActions from '../../actions/basAgentActions';
import * as InventoryActions from '../../actions/inventoryActions';

class BasAgentsPage extends Component {
    static propTypes = {
        basAgents:     array,
        companyInfo:   object,
        currentScopes: array,
        history:       object,
        location:      object,
        message:       string,
        updatedAt:     object
    }

    state = {
        agent:                      {},
        assignAgentModalOpen:       false,
        resetConfirmationModalOpen: false,
        deleteAgentModalOpen:       false,
        newAgentModalOpen:          false,
        renameAgentModalOpen:       false,
        unAssignAgentModalOpen:     false,
        searchFilter:               '',
        linkModalOpen:              false
    }

    componentDidMount() {
    }

    handleToggleNewAgentModal = () => {
        this.setState(state => ({
            newAgentModalOpen: !state.newAgentModalOpen
        }));
    }

    handleToggleAssignAgentModal = (agent = {}) => {
        this.setState(state => ({
            agent,
            assignAgentModalOpen: !state.assignAgentModalOpen
        }));
    }

    handleToggleUnAssignAgentModal = (agent = {}) => {
        this.setState(state => ({
            agent,
            unAssignAgentModalOpen: !state.unAssignAgentModalOpen
        }));
    }

    handleToggleDeleteAgentModal = () => {
        this.setState(state => ({
            deleteAgentModalOpen: !state.deleteAgentModalOpen
        }));
    }

    handleToggleRenameAgentModal = (agent = {}) => {
        this.setState(state => ({
            agent,
            renameAgentModalOpen: !state.renameAgentModalOpen
        }));
    }

    handleToggleResetConfirmationModal = (agent = {}) => {
        this.setState(state => ({
            agentId:                    agent.id,
            agentName:                  agent.name,
            resetConfirmationModalOpen: !state.resetConfirmationModalOpen
        }));
    }

    handleDelete = (agent = {}) => {
        this.setState(state => ({
            agentId:              agent.id,
            agentName:            agent.name,
            deleteAgentModalOpen: true
        }));
    }

    handleSort = (property) => {
        return (event) => {
            this.props.reorderAgents(property);
        };
    }

    handlePageRoute = () => {
        const { history, location } = this.props;

        history.push('/iothub' + location.search);
    }

    handleSearch = (searchFilter) => {
        this.setState(state => ({
            searchFilter: searchFilter
        }));
    }

    handleFactoryReset = () => {
        const { agentId } = this.state;

        this.props.factoryResetAgent(agentId);
        this.handleToggleResetConfirmationModal();
    }

    handleStopInventoryScan = (agent) => {
        const {id, driverConfiguration} = agent;
        this.props.stopInventoryScan(id, driverConfiguration[0].id);
    }

    handleToggleSiteLinking = (agent = {}) => {
        this.setState(state => ({
            agent:         agent,
            agentId:       agent.id,
            agentName:     agent.name,
            linkModalOpen: !state.linkModalOpen
        }));
    };

    render() {
        let {
            basAgents,
            companyInfo,
            currentScopes,
            order,
            orderBy
        } = this.props;

        const isFullHubAllowed = isAllowed(currentScopes, Permissions('iothubFull'));

        return (
            <React.Fragment>
                <EsmsPage
                    parents={[companyInfo.companyName]}
                    handlers={[this.handlePageRoute]}
                    title="BAS Agents"
                    subtitle={(
                        <ElapsedTime
                            dateTime={this.props.updatedAt}
                            render={(time) => `Updated ${time}`}
                        />
                    )}
                >
                    <ActionBar
                        onSearch={this.handleSearch}
                    >
                        <ActionBarItem
                            onClick={this.handleToggleNewAgentModal}
                            hidden={!isFullHubAllowed}
                            type="add"
                        >
                            New Agent
                        </ActionBarItem>
                    </ActionBar>
                    <BasAgentsTable
                        agents={basAgents}
                        companyInfo={companyInfo}
                        isFullHubAllowed={isFullHubAllowed}
                        order={order}
                        orderBy={orderBy}
                        onAssignAgentModal={this.handleToggleAssignAgentModal}
                        onDeleteModal={this.handleDelete}
                        onHandleSiteLinking={this.handleToggleSiteLinking}
                        onUnAssignAgentModal={this.handleToggleUnAssignAgentModal}
                        onRenameAgentModal={this.handleToggleRenameAgentModal}
                        onResetConfirmationModal={this.handleToggleResetConfirmationModal}
                        onStopInventoryScan={this.handleStopInventoryScan}
                        onSort={this.handleSort}
                        searchFilter={this.state.searchFilter}
                    />
                </EsmsPage>
                { this.state.newAgentModalOpen ? 
                    <NewAgentModal
                        open={this.state.newAgentModalOpen}
                        close={this.handleToggleNewAgentModal}
                        title="New Agent"
                    />
                    : 
                    null
                }
                <AssignAgentModal
                    open={this.state.assignAgentModalOpen}
                    close={this.handleToggleAssignAgentModal}
                    agent={this.state.agent}
                    title={`Assign Agent to ${this.state.agent.name}`}
                />
                <UnAssignAgentModal
                    open={this.state.unAssignAgentModalOpen}
                    close={this.handleToggleUnAssignAgentModal}
                    agent={this.state.agent}
                    title={`Unassign Agent ${this.state.agent.name}`}
                />
                <ResetAgentModal
                    open={this.state.resetConfirmationModalOpen}
                    confirm={this.handleFactoryReset}
                    title="Reset Agent Action"
                    close={this.handleToggleResetConfirmationModal}
                    agentName={this.state.agentName}
                    agentId={this.state.agentId}
                />
                <DeleteAgentModal
                    open={this.state.deleteAgentModalOpen}
                    close={this.handleToggleDeleteAgentModal}
                    agentId={this.state.agentId}
                    agentName={this.state.agentName}
                    title={`Delete Agent Configuration: ${this.state.agentName}`}
                />
                <RenameAgentModal
                    open={this.state.renameAgentModalOpen}
                    close={this.handleToggleRenameAgentModal}
                    agent={this.state.agent}
                    title={`Rename Agent ${this.state.agent.name}`}
                />
                { this.state.linkModalOpen ? 
                    <AgentLinkSiteModal
                        agentId={this.state.agentId}
                        title={`Link Sites to ${this.state.agentName}`}
                        open={this.state.linkModalOpen}
                        close={this.handleToggleSiteLinking}
                    /> 
                    : null
                }
            </React.Fragment>
        );
    }
}

export const mapStateToProps = state => {
    const { basAgents, order, orderBy: orderByKey, updatedAt } = state.basAgent;
    return {
        basAgents:     orderBy(Object.values(basAgents), [orderByKey], order),
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes,
        message:       state.messages.message,
        order,
        orderBy:       orderByKey,
        updatedAt
    };
};

const mapDispatchToProps = {
    ...BasAgentActions,
    ...InventoryActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BasAgentsPage));
